import React, { Component } from 'react';
import { Table, Button, Alert, Spinner  } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Card, CardHeader, CardBody, Row, Col, Collapse, Input } from 'reactstrap';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineReload } from 'react-icons/ai';
import { FaEdit, FaPlus, FaTrashAlt, FaCheckSquare } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;


export class ConsultarReportes extends Component {
    static displayName = ConsultarReportes.name;

    constructor(props) {
        super(props);
        this.state = {
            iduser: 0,
            roles: [],
            numeroCertificados: 0,
            certificados: [],
            loading: true,
            totalPageA: 0,
            actualPage: 1,
            limite: 10,
            siblingCount: 1,
            currentPage: 1,
            currentTotalPages: 0
        };

    }

    componentDidMount() {
        this.populateInfoData();      
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    setPagePrevious() {
        if (this.state.currentPage !== 1) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p - 1
            });
        }
    }

    setPageNext() {
        if (this.state.currentPage !== this.state.totalPageA) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p + 1
            });
        }
    }

    setPage = (pageNum) => {
        this.setState({ currentPage: pageNum })
    }

    setYouAreMySibling(num) {
        let actualPage = this.state.currentPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageA;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite), actualPage: 1, currentPage: 1 });

    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num });
        this.reLoadTotalPage(this.state.certificados.length, num);
    }

    render() {
        const indexOfLastPost = this.state.currentPage * this.state.limite;

        const indexOfFirstPost = indexOfLastPost - this.state.limite;

        const currentPosts = this.state.certificados.slice(indexOfFirstPost, indexOfLastPost);

        const pageNumbers = []

        for (let i = 1; i <= Math.ceil(this.state.certificados.length / this.state.limite); i++) {
            pageNumbers.push(i);
        }

        let contents = this.state.loading
            ? <><Spinner animation="grow" /></>
            : <><strong>Certificados generados: </strong> {this.state.numeroCertificados} <hr />
                {this.state.certificados.length > 0 ?
                    <>
                        <ReactHTMLTableToExcel
                            id="table-xls-button"
                            className="page-link"
                            table="table-to-xls"
                            filename="Data"
                            sheet="sheet1"
                            buttonText="Exportar como Excel"
                        />
                        <br/>
                        <div className="w-full flex justify-around">
                            <Row hidden={this.state.certificados.length === 0} id={'newPagination'}>
                                <Col xs="2">
                                    <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                        <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                                        <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                                        <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                                        <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                                        <option key={"sel-50"} selected={50 == this.state.limite} value={50}>{50}</option>
                                        <option key={"sel-100"} selected={100 == this.state.limite} value={100}>{100}</option>
                                    </Input>
                                </Col>
                                <Col>
                                    <Pagination hidden={pageNumbers.length < 1} >
                                        <PaginationItem active={this.state.currentPage === 1} onClick={() => { this.setPage(1); }}>
                                            <PaginationLink>
                                                {1}
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === 1} onClick={() => { this.setPagePrevious(); }}>
                                            <PaginationLink previous />
                                        </PaginationItem>
                                        {pageNumbers.map((page, i) =>
                                        (
                                            <PaginationItem key={i} hidden={i + 1 === 1 || i + 1 === this.state.totalPageA || !this.setYouAreMySibling(i + 1)} active={this.state.currentPage === i + 1} onClick={() => { this.setPage(i + 1); }}>
                                                <PaginationLink>
                                                    {i + 1}
                                                </PaginationLink>
                                            </PaginationItem>)
                                        )}
                                        <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPageNext(); }}>
                                            <PaginationLink next />
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageA === 1} active={this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPage(this.state.totalPageA); }}>
                                            <PaginationLink>
                                                {this.state.totalPageA}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </Col>
                            </Row>
                        </div>

                        <div>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Estudiante</th>
                                        <th>Matricula</th>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Certificado</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {currentPosts.map((act, i) => {
                                        return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                            <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                            {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.codestudiante}</td> : <td>-</td>}
                                            {act.ultimoCambio !== null ? <td>{act.ultimoCambio.split(".")[0]}</td> : <td>-</td>}
                                            {act.agrupacion !== null ? <td>{act.agrupacion}</td> : <td>-</td>}
                                            {act.rutapdf != null ? <td><a className="btn btn-sm btn-primary" href={"https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/" + act.rutapdf.split(",")[1] + "/" + act.codigo + ".pdf" } target="_blank">Ver/Descargar</a></td> : <td>-</td>}
                                        </tr>
                                    }
                                    )}
                                </tbody>

                            </Table>
                        </div>
                        <div className="hidden-element">
                            <Table id="table-to-xls">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Estudiante</th>
                                        <th>Matricula</th>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Link</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.certificados.map((act, i) => {
                                        return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                            <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                            {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.codestudiante}</td> : <td>-</td>}
                                            {act.ultimoCambio !== null ? <td>{act.ultimoCambio.split(".")[0]}</td> : <td>-</td>}
                                            {act.agrupacion !== null ? <td>{act.agrupacion}</td> : <td>-</td>}
                                            {act.rutapdf != null ? <td>{"https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/" + act.rutapdf.split(",")[1] + "/" + act.codigo + ".pdf"}</td> : <td>-</td>}
                                        </tr>
                                    }
                                    )}
                                </tbody>

                            </Table>
                        </div>
                    </>
                    : <><div /></>}
                {this.state.certificados.length === 0 ? < Card body className="text-center py-3">No se encontraron Resultados.</Card> : <></>}
            </>
        return (
            <div>
                {contents}
            </div>
        );
    }

    populateInfoData() {

        fetch(localBack + '/api/Estadisticas', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {                    
                    this.setState({
                        numeroCertificados: data.objDatos.certificadosGenerados,
                    });
                });

        fetch(localBack + '/api/Certificado', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    certificados: data.objDatos,
                    loading: false,
                });
                this.reLoadTotalPage(this.state.certificados.length, this.state.limite);
            });

    }



}
ConsultarReportes.contextType = AppContext;
export default withRouter(ConsultarReportes);